(() => {
  const VARIANT_ID = 46808434573569;
  const BUSY_FLAG = '__shippingProtectionBusy';
  const CHECKOUT_PATHNAME = '/checkout';
  const CART_PATHNAME = '/cart';

  if (typeof window === 'undefined') {
    return;
  }

  const { location } = window;
  const currentPath = location.pathname || '';
  const currentHost = location.hostname || '';

  if (currentPath.startsWith(CHECKOUT_PATHNAME) || currentHost.startsWith('checkout')) {
    return;
  }

  const getEventPath = (event) => {
    if (typeof event.composedPath === 'function') {
      return event.composedPath();
    }
    const path = [];
    let node = event.target;
    while (node) {
      path.push(node);
      node = node.parentNode;
    }
    path.push(window);
    return path;
  };

  const isCheckoutUrl = (urlString) => {
    if (!urlString) {
      return false;
    }
    let url;
    try {
      url = new URL(urlString, location.href);
    } catch (error) {
      return false;
    }

    return url.pathname === CHECKOUT_PATHNAME;
  };

  const isCartUrl = (urlString) => {
    if (!urlString) {
      return false;
    }
    let url;
    try {
      url = new URL(urlString, location.href);
    } catch (error) {
      return false;
    }

    return url.pathname === CART_PATHNAME;
  };

  const isSubmitControl = (node) => {
    if (!node) {
      return false;
    }
    if (node instanceof HTMLButtonElement) {
      const type = (node.getAttribute('type') || 'submit').toLowerCase();
      return type === 'submit';
    }
    if (node instanceof HTMLInputElement) {
      const type = (node.getAttribute('type') || 'submit').toLowerCase();
      return type === 'submit';
    }
    return false;
  };

  const isCheckoutSubmitter = (node) => {
    if (!isSubmitControl(node)) {
      return false;
    }
    const name = (node.getAttribute('name') || '').toLowerCase();
    if (name === 'checkout') {
      return true;
    }
    const value = (node.getAttribute('value') || '').toLowerCase();
    if (value === 'checkout') {
      return true;
    }
    const dataAttr = (node.getAttribute('data-checkout') || node.getAttribute('data-cart-checkout') || '').toLowerCase();
    return dataAttr === 'true';
  };

  const resolveDestination = (actionUrl) => {
    if (isCheckoutUrl(actionUrl)) {
      return new URL(actionUrl, location.href).toString();
    }
    return new URL(CHECKOUT_PATHNAME, location.href).toString();
  };

  const ensureProtectionLine = async () => {
    const cartResponse = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!cartResponse.ok) {
      throw new Error('Cart fetch failed');
    }

    const cart = await cartResponse.json();

    if (Array.isArray(cart.items) && cart.items.some((item) => Number(item.variant_id) === VARIANT_ID)) {
      return;
    }

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: VARIANT_ID,
            quantity: 1,
          },
        ],
      }),
    });

    if (!addResponse.ok) {
      throw new Error('Add to cart failed');
    }
  };

  const handleIntercept = (event, destinationUrl) => {
    if (!destinationUrl) {
      return;
    }

    if (window[BUSY_FLAG]) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    event.stopPropagation();
    window[BUSY_FLAG] = true;

    ensureProtectionLine()
      .catch(() => undefined)
      .finally(() => {
        window.location.assign(destinationUrl);
        window.setTimeout(() => {
          window[BUSY_FLAG] = false;
        }, 1000);
      });
  };

  let lastSubmitter = null;

  document.addEventListener(
    'click',
    (event) => {
      const path = getEventPath(event);
      const submitControl = path.find((node) => isCheckoutSubmitter(node));
      if (submitControl && submitControl.form) {
        lastSubmitter = submitControl;
      }

      const anchor = path.find(
        (node) =>
          node instanceof HTMLAnchorElement &&
          node.href &&
          !node.hasAttribute('download') &&
          node.target !== '_blank' &&
          isCheckoutUrl(node.getAttribute('href') || node.href)
      );

      if (!anchor) {
        const btn = path.find(
          (node) =>
            node instanceof HTMLButtonElement &&
            (node.id === 'kaching-cart__checkout-button' ||
              (node.getAttribute('name') || '').toLowerCase() === 'checkout' ||
              /^(proceed to )?checkout$/i.test((node.getAttribute('aria-label') || '').trim()))
        );
        if (!btn) {
          return;
        }
        handleIntercept(event, resolveDestination('/checkout'));
        return;
      }

      const url = new URL(anchor.getAttribute('href') || anchor.href, location.href);
      handleIntercept(event, url.toString());
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const path = getEventPath(event);
      const form = path.find((node) => node instanceof HTMLFormElement);

      if (!form) {
        return;
      }

      const submitter = event.submitter || lastSubmitter;
      lastSubmitter = null;

      const rawAction =
        (submitter && (submitter.getAttribute('formaction') || submitter.formAction)) ||
        form.getAttribute('action') ||
        '';
      const method = (form.getAttribute('method') || 'get').toLowerCase();

      const postsToCheckout = isCheckoutUrl(rawAction);
      const checkoutButtonSubmit = method === 'post' && isCartUrl(rawAction) && isCheckoutSubmitter(submitter);

      if (!postsToCheckout && !checkoutButtonSubmit) {
        return;
      }

      if (form.target && form.target !== '_self') {
        return;
      }

      const destination = resolveDestination(rawAction);
      handleIntercept(event, destination);
    },
    true
  );
})();
